<template>
  <transition name="fade" appear>
    <a
      :class="{ 'alternate-theme': alternateTheme }"
      v-if="external || link[0] === '#'"
      :href="link"
      > <span>{{ text }}</span></a
    >
    <button :class="{ 'alternate-theme': alternateTheme }" v-else>
      <span>{{ text }}</span>
    </button>
  </transition>
</template>

<script>
export default {
  name: "TimeButton",
  props: {
    text: String,
    link: String,
    alternateTheme: Boolean,
    external: Boolean,
  },
};
</script>

<style lang="scss" scoped>
a,
button {
  font-size: 17px;  
  line-height: 1.37;
  text-decoration: none;
  background: var(--greyGradient);
  color: var(--white);
  border: none;
  text-transform: uppercase;
  padding: 12px 45px;  
  user-select: none;
  display: inline-block;
  position: relative;
  transition: 0.2s all ease-in-out;
  border:1px solid var(--accent);
  cursor: pointer;
  span {
    position: relative;
  }
  &:before {
    content:"";
    transition: 0.2s all ease-in-out;
    position: absolute;
    top:0;
    left:0;
    width:100%;
    height:100%;
    background: var(--blueGradient);
    opacity: 0;
  }  
  &.selected {
    pointer-events: none;    
    &:before {
      opacity: 1;
    }
  }
  @media (hover: hover) {
    &:not(.disabled) {
      &:hover {
        background: var(--dark-blue);
      }
    }
  }
}
</style>